/**
 * @namespace source.folders
 */

/**
 * @typedef ListSettings
 * @type Object
 * @property {object} paging
 * @property {string} paging.cursor
 * @property {number} paging.size
 * @property {object} sort
 * @property {string} sort.order
 * @property {string} sort.field
 */

/**
 * @typedef List
 * @type Object
 * @property {Array} data
 * @property {Object} paging
 * @property {string} paging.cursor
 * @property {number} paging.size
 */

import { toFolder } from './mappers/folder';
import { toError } from './parsers/error';
import { MediaType } from '../../constants/MediaType';
export function initFolders(settings, http) {
  function mapFolderList(res) {
    res.data = (res.data.folders || []).map(toFolder);
    return res;
  }

  /**
   * @summary Return the list of folders
   * @memberof source.folders
   * @param {String} folderId
   * @param {ListSettings} options
   * @returns {Promise}
   * @fulfill {List[]} List with Folders
   * @reject {Error}
   */
  function list(folderId, options) {
    options = options || {};
    return http.get(settings.apiUrl + "/folders", {
      media_type: options.mediaType || MediaType.Picture,
      folder_id: folderId || null
    }, {
      headers: options.headers || {}
    }).then(mapFolderList).catch(toError);
  }
  function removeFolder(folderId, options) {
    const url = settings.apiUrl + "/folders/" + folderId + "/delete";
    const postOptions = {
      headers: options.headers || {}
    };
    return http.post(url, null, null, postOptions).then(function (res) {
      res.data = {
        id: folderId
      };
      return res;
    }).catch(toError);
  }

  /**
   * @summary Removes the list of folders with given ids
   * @memberof source.folders
   * @param {string[]} folderIds Array of folder ids
   * @param {Object} options
   * @returns {Promise[]}
   */
  function remove(folderIds, options) {
    options = options || {};
    return folderIds.map(function (folderId) {
      return removeFolder(folderId, options);
    });
  }
  return {
    list,
    remove
  };
}